module.exports = __webpack_public_path__ + "img/DE00662.5401aec7.png";